import { GameTypeAvailableGuard } from './core/guards/game-type-available.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AuthGuard,
  NegateAuthGuard,
  NoStudentGamesGuard,
  UserTypeGuard,
  RedirectToV3Guard,
} from '@core/guards';
import { SubscriptionGuard } from '@core/guards/subscription.guard';
import { DashboardComponent } from './pages-v3/dashboard/dashboard.component';
import { DevelopingGuard } from '@core/guards/developing.guard';
import { GameMaterialPackComponent } from '@v3/developer-docs/game-material-pack/game-material-pack.component';

const routes: Routes = [
  // Корневой роут с guard'ом для автоматической проверки всех дочерних роутов
  {
    path: '',
    canActivateChild: [RedirectToV3Guard],
    children: [
      {
        path: 'material-pack',
        component: GameMaterialPackComponent,
        canActivate: [DevelopingGuard],
        canActivateChild: [DevelopingGuard],
      },
      {
        path: 'test-view',
        loadChildren: () =>
          import('./pages/test-view/test-view.module').then((mod) => mod.TestViewModule),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
      },
      {
        path: 'diploma',
        loadChildren: () => import('./pages/diploma/diploma.module').then((m) => m.DiplomaModule),
      },
      {
        path: 'promotions',
        loadChildren: () =>
          import('./pages/promotions/promotions.module').then((mod) => mod.PromotionsModule),
      },
      {
        path: 'exercises/:taskSet/:task',
        loadChildren: () =>
          import('./pages/exercises/exercise/exercise.module').then((mod) => mod.ExerciseModule),
      },
      {
        path: 'exercises/:taskId',
        loadChildren: () =>
          import('./pages-v3/exercises/pages/exercise-solve/exercise-solve.module').then(
            (mod) => mod.ExerciseSolveModule,
          ),
      },
      {
        path: 'login',
        loadChildren: () =>
          import('./pages/authorization/authorization.module').then(
            (mod) => mod.AuthorizationModule,
          ),
        canActivate: [NegateAuthGuard],
      },
      {
        path: 'sign-up',
        loadChildren: () =>
          import('app/pages-v3/registration/registration.module').then((m) => m.RegistrationModule),
        canActivate: [NegateAuthGuard],
      },

      // Алиас для более коротких url, которые используются в рекламе в соц. сетях и подобном
      // (mindskills.online/rg/vk вместо mindskills.online/sign-up/vk)
      {
        path: 'rg',
        redirectTo: '/sign-up',
        pathMatch: 'full',
      },
      {
        path: 'rg/:registration_url',
        redirectTo: '/sign-up/:registration_url',
      },
      {
        path: 'prices',
        loadChildren: () =>
          import('./pages/prices/prices.module').then((mod) => mod.FakePricesModule),
        canActivate: [NegateAuthGuard],
      },
      {
        path: 'recharge',
        loadChildren: () =>
          import('./pages/recharge/recharge.module').then((mod) => mod.RechargeModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'g/:gameType',
        loadChildren: () => import('./pages/games/game/game.module').then((mod) => mod.GameModule),
        canActivate: [
          AuthGuard,
          SubscriptionGuard,
          GameTypeAvailableGuard,
          UserTypeGuard,
          NoStudentGamesGuard,
        ],
        data: {
          userTypes: ['teacher', 'coach', 'moderator'],
        },
      },
      {
        path: 'multiplayer',
        loadComponent: () =>
          import('./pages/games/multiplayer/multiplayer.component').then(
            (c) => c.MultiplayerComponent,
          ),
        canActivate: [AuthGuard, SubscriptionGuard],
        data: {
          pageNameKey: 'subscriptionGuard.pageNames.multiplayer',
        },
      },
      {
        path: '',
        component: DashboardComponent,
        loadChildren: () =>
          import('./pages-v3/dashboard/dashboard.module').then((mod) => mod.DashboardModule),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
